// extracted by mini-css-extract-plugin
export default {"container":"footer_container__Wnbmt","section":"footer_section__hEYJI","logo":"footer_logo__jnh15"};